module.exports = __webpack_public_path__ + "js/stellarium-web-engine.2833a89f.wasm";